import styled from "@emotion/styled";
import { motion } from "framer-motion";

export const StepperContainer = styled.div`
  width: 100%;
  padding: 24px 0;
  margin-top: 16px;
  overflow-x: auto;
`;

export const StepperTrack = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  position: relative;
  min-width: 800px; /* Ensure it doesn't squish too much */
`;

export const ProgressLineBackground = styled.div`
  position: absolute;
  top: 20px;
  left: 0;
  right: 0;
  height: 4px;
  background-color: #e5e7eb;
  z-index: 0;
  border-radius: 2px;
`;

export const ProgressLineFill = styled(motion.div)`
  position: absolute;
  top: 20px;
  left: 0;
  height: 4px;
  background-color: #0d9488;
  z-index: 1;
  border-radius: 2px;
  transform-origin: left;
`;

export const StepItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  z-index: 2;
  width: 100px;
`;

export const IconWrapper = styled(motion.div)<{
  active: boolean;
  completed: boolean;
  cancelled?: boolean;
}>`
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background-color: ${(props) =>
    props.cancelled
      ? "#ef4444"
      : props.completed || props.active
        ? "#0d9488"
        : "#ffffff"};
  border: 2px solid
    ${(props) =>
      props.cancelled
        ? "#ef4444"
        : props.completed || props.active
          ? "#0d9488"
          : "#e5e7eb"};
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${(props) =>
    props.completed || props.active || props.cancelled ? "#ffffff" : "#9ca3af"};
  margin-bottom: 8px;
  transition: all 0.3s ease;
  box-shadow: ${(props) =>
    props.active ? "0 0 0 4px rgba(13, 148, 136, 0.2)" : "none"};
`;

export const StepLabel = styled.span<{
  active: boolean;
  completed: boolean;
  cancelled?: boolean;
}>`
  font-size: 12px;
  font-weight: ${(props) => (props.active ? "600" : "500")};
  color: ${(props) =>
    props.cancelled
      ? "#ef4444"
      : props.completed || props.active
        ? "#111827"
        : "#9ca3af"};
  text-align: center;
  line-height: 1.4;
`;

export const StepDate = styled.span`
  font-size: 10px;
  color: #6b7280;
  margin-top: 4px;
`;
